<template>
  <main class="create-customer-page">
    <header>
      <router-link :to="toCustomers">← Customers</router-link>
      <h1>Add customer</h1>
      <p>Create the company and its first user. Fields marked * are required.</p>
    </header>
    <CreateCustomerForm :route-after-save="toCustomers" />
  </main>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import { STAFF_CUSTOMERS_LIST } from '@/types/router'
import CreateCustomerForm from '@/views/Components/Customer/CreateCustomerForm.vue'

export default defineComponent({
  name: 'CustomersCreate',
  components: { CreateCustomerForm },
  setup() {
    const toCustomers = { name: STAFF_CUSTOMERS_LIST }
    return { toCustomers }
  },
})
</script>
